import { TextColor } from '@lyra/core/utils/text'
import React from 'react'
import { Stack, StackProps, XStack } from 'tamagui'

import TextInterDEPRECATED from '../TextInterDEPRECATED'

type Props = {
  label: string | React.ReactNode
  value: string | React.ReactNode
  textValueColor?: TextColor
  noPadding?: boolean
} & StackProps

export default function RowItemDEPRECATED({ label, value, textValueColor, ...styleProps }: Props) {
  return (
    <XStack width="100%" alignItems="center" {...styleProps}>
      <Stack>
        {typeof label === 'string' ? (
          <TextInterDEPRECATED color="secondary">{label}</TextInterDEPRECATED>
        ) : (
          label
        )}
      </Stack>
      <Stack marginLeft="auto">
        {typeof value === 'string' ? (
          <TextInterDEPRECATED color={textValueColor}>{value}</TextInterDEPRECATED>
        ) : (
          value
        )}
      </Stack>
    </XStack>
  )
}
